/**
 * Aktif oyun oturumu durumu.
 */
export class GameSession {
  private score = 0;
  private active = false;

  get isActive(): boolean {
    return this.active;
  }

  get currentScore(): number {
    return this.score;
  }

  start(): void {
    this.score = 0;
    this.active = true;
  }

  incrementScore(): void {
    this.score += 1;
  }

  end(): number {
    this.active = false;
    return this.score;
  }

  reset(): void {
    this.score = 0;
    this.active = false;
  }
}
